import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavBar from './AdminNavBar';

function AdminLayout() {
  return (
    <div className="min-h-screen bg-gradient-civote">
      <AdminNavBar />
      <Outlet />
    </div>
  );
}

export default AdminLayout;
